import { render, staticRenderFns } from "./ym-harvest.vue?vue&type=template&id=2965b057&scoped=true&"
import script from "./ym-harvest.vue?vue&type=script&lang=js&"
export * from "./ym-harvest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965b057",
  null
  
)

export default component.exports